module.exports = __webpack_public_path__ + "img/tutorial_img_1_2.07bf1152.png";